// extracted by mini-css-extract-plugin
export default {"page":"aeQNxABg","main":"jQsngr7U","title":"wQ6PqiaZ","titleInner":"pHIvq_Wn","titleTotal":"r7OxCgXB","checkboxBlock":"FtspjQ27","goodsWrapper":"l7Y3nLaq","productDetails":"cmCT2okL","creditButton":"ihgpfTmP","payButton":"apQFbyOv","totalTitle":"LgJVop5D","totalInfoInner":"uXQ3Wy3V","buttonContainer":"Yr3v_l4P","disabled":"elmuImjx","backToGameButton":"pVqiSl7N"};
    if(module.hot) {
      // 1738090061686
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  